import { useRef, useState, useEffect } from "react";
import clsx from "clsx";
import { FaAngleDown, FaAngleUp, FaCheck } from "react-icons/fa";

import { Text } from "components/common";
import useOnClickOutside from "hooks";
import classes from "./PeriodDropdown.module.css";

const PeriodDropdown = ({
  isActive,
  items,
  selectedValue,
  onSelect,
  setIsActive,
}) => {
  const ref = useRef(null);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useOnClickOutside(ref, () => setIsActive(false));

  return (
    <div className={classes.dropdown} ref={ref}>
      <div
        className={clsx(classes.labelContainer)}
        onClick={() => setIsActive((prev) => !prev)}
      >
        <Text primitive100>{selectedValue.text}</Text>
        {isActive ? (
          <FaAngleUp className={classes.arrow} />
        ) : (
          <FaAngleDown className={classes.arrow} />
        )}
      </div>

      <div
        ref={dropdownRef}
        className={clsx(classes.dropdownMain, isActive && classes.active)}
        role="listbox"
        aria-expanded={isActive}
      >
        <div className={clsx(classes.list, "overflow")}>
          {items?.map((item, idx) => (
            <div
              key={`item-${idx}`}
              className={clsx(
                classes.listItem,
                selectedValue?.text === item?.text && classes.active
              )}
              onClick={(e) => {
                setIsActive(false);

                onSelect(item);
              }}
            >
              <Text medium>{item?.text}</Text>
              {selectedValue.text === item.text && (
                <FaCheck className={classes.checkIcon} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PeriodDropdown;
